// removed by extract-text-webpack-plugin
module.exports = {"spacer":"event-links__spacer__3Ktzw"};


//////////////////
// WEBPACK FOOTER
// ./src/components/details/event-links.scss
// module id = 1345
// module chunks = 1